export const HIGH = 'high'
export const LOW = 'low'
